import { LandingHeaderWelcomePart } from '@modules/Landing/Components/DesktopLanding/LandingHeader/LandingHeaderWelcomePart/LandingHeaderWelcomePart';
import { LandingHeaderPDFViewPart } from '@modules/Landing/Components/DesktopLanding/LandingHeader/LandingHeaderPDFViewPart/LandingHeaderPDFViewPart';
import css from './LandingHeader.module.css';

export const LandingHeader: React.FC = () => {
    return (
        <section className={css.section}>
            <LandingHeaderWelcomePart />
            <LandingHeaderPDFViewPart />
        </section>
    );
};
